import React, { useCallback, useState } from 'react';

import { IAward } from '../../../../../../store/admin/eventAwards/store';

import { IOption } from '../../../../../../components/Select/Select';
import { IOnAwardChange } from '../AssignAwardsTable';
import { AwardRowActions } from './AwardRowActions';
import { AwardRowFields } from './AwardRowFields';

interface IAwardRow {
  award: IAward;
  newAward: IAward;
  newAwardRow?: boolean;
  onAwardChange: IOnAwardChange;
  onRemove?: any;
  onSave: any;
  playersOptions: IOption[];
  toggleSetShowNewAwardRow?: () => void;
}

export const AwardRow = (props: IAwardRow) => {
  const {
    award,
    newAward,
    newAwardRow,
    onAwardChange,
    onRemove,
    onSave,
    playersOptions,
    toggleSetShowNewAwardRow
  } = props;

  const [editMode, setEditMode] = useState(newAwardRow !== undefined);

  const onToggleEditMode = useCallback(() => {
    onAwardChange('id')(award.id);
    setEditMode(!editMode);
  }, [editMode]);

  return (
    <>
      <AwardRowFields
        award={award}
        newAward={newAward}
        onAwardChange={onAwardChange}
        playersOptions={playersOptions}
        editMode={editMode}
        onToggleEditMode={onToggleEditMode}
      />
      <AwardRowActions
        award={award}
        newAward={newAward}
        onSave={onSave}
        onRemove={onRemove}
        editMode={editMode}
        newAwardRow={newAwardRow}
        toggleSetShowNewAwardRow={toggleSetShowNewAwardRow}
        onToggleEditMode={onToggleEditMode}
      />
    </>
  );
};
